module.exports = __webpack_public_path__ + "static/mission-305505722a6292d21263164354e59d57.png";